const styles = {
  container: {
    gap: "1rem",
    display: "flex",
    flexDirection: "column",
  },
  heading: {
    fontWeight: 600,
    color: "#1B1C1B",
    lineHeight: "2.25rem",
    fontSize: "1.25rem",
  },
  formContainer: { display: "grid", gap: "0.5rem", paddingTop: "1rem" },
  subHeading: {
    fontWeight: 600,
    color: "#334155",
    lineHeight: "2rem",
    fontSize: "1.125rem",
  },
  spinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  addImageButton: {
    width: "13rem",
    height: "2.5rem",
    textTransform: "none",
    color: "#006AFF",
    fontWeight: 600,
    lineHeight: "1.5rem",
    fontSize: "0.875rem",
  },
  addedImagesContainer: {
    borderRadius: "4px",
    border: "1px solid",
    borderColor: "#E2E8F0",
  },
  addedImageContainer: {
    height: "2rem",
    padding: "1rem",
  },
  imageGrid: {
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
  },
  select_field: {
    borderRadius: "0.75rem",
    color: "#ED0000",
    height: "2.5rem",
  },
  addedImage: {
    height: "2rem",
    width: "2rem",
    borderRadius: "4px",
  },
  imageName: {
    fontWeight: 600,
    fontSize: "1rem",
    color: "#1B1C1B",
    lineHeight: "1.5rem",
  },
  imageSize: {
    fontWeight: 500,
    fontSize: "0.75rem",
    color: "#475569",
    lineHeight: "1rem",
  },
  trashIcon: {
    height: "1.5rem",
    width: "1.5rem",
  },
  buttonsGrid: {
    paddingTop: "3rem",
  },
  cancelButton: {
    borderColor: "#CBD5E1",
    borderRadius: "small",
    color: "#475569",
    fontWeight: 600,
    lineHeight: "1.5rem",
    fontSize: "0.875rem",
    textTransform: "none",
  },
  saveButton: {
    borderColor: "#006AFF",
    borderRadius: "small",
    fontWeight: 600,
    lineHeight: "1.5rem",
    fontSize: "0.875rem",
    textTransform: "none",
    color: "#FEFEFE",
  },
  parcelDetailsContainer: {
    marginLeft: "2rem",
    marginRight: "2rem",
    padding: "2rem",
    border: "1px solid",
    borderColor: "#E2E8F0",
    borderRadius: "4px",
  },
};

export default styles;
